<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App',
    };
</script>

<style>
    html,
    body {
        width: 100%;
        height: 100%;
        font-size: 14px;
        background-color: #f2f2f2;
    }

    #app {
        width: 100%;
        max-width: 600px;
        height: 100%;
        background-color: #f2f2f2;
        position: relative;
        overflow: auto;
        margin: 0 auto;
        padding: 0;
    }

    * {
        margin: 0;
        padding: 0;
        font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
            'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    li {
        list-style: none;
    }

    /* 吸附tabbar */
    .tabbarSticky {
        position: sticky;
        bottom: 0;
        z-index: 1;
    }

    /* 试题公共样式 */
    .globalQuestionListDiv {
        font-size: 16px;
        line-height: 46px;
        padding: 10px 16px;
        box-sizing: border-box;
        background-color: #fff;
    }

    .globalQuestionContent {
        font-size: 16px;
        line-height: 40px;
        font-weight: bold;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
    }

    .globalQuestionAnswerInfo {
        display: flex;
        margin: 15px 0;
        line-height: 26px;
    }

    .globalQuestionAnswerIndex {
        width: 26px;
        min-width: 26px;
        height: 26px;
        text-align: center;
        border-radius: 50%;
        border: 1px solid #aaa;
        box-sizing: border-box;
        margin-right: 5px;
    }

    .globalQuestionContentImgDiv,
    .globalQuestionAnswerImgDiv {
        line-height: 1;
    }

    .globalQuestionContentImg + .globalQuestionContentImg,
    .globalQuestionAnswerImg + .globalQuestionAnswerImg {
        margin-left: 5px;
    }

    .globalQuestioAnswerCard {
        background-color: #f2f2f2;
        border-radius: 5px;
        padding: 10px 16px;
        box-sizing: border-box;
        line-height: 30px;
        text-align: center;
    }

    .globalQuestioAnswerDiv {
        display: flex;
        justify-content: space-around;
    }

    .globalQuestionExplain {
        background-color: #fff;
        margin-top: 10px;
        padding: 10px 16px;
        box-sizing: border-box;
        font-size: 16px;
        line-height: 46px;
    }

    .globalCorrectAnswer {
        color: #07c160;
    }

    .globalCorrectAnswer .globalQuestionAnswerIndex {
        color: #fff;
        border-color: #07c160;
        background-color: #07c160;
    }

    .globalWrongAnswer {
        color: #ee0a24;
    }

    .globalWrongAnswer .globalQuestionAnswerIndex {
        color: #fff;
        border-color: #ee0a24;
        background-color: #ee0a24;
    }

    /* 答题卡公共样式 */
    .globalAnswerSheetHeader {
        position: sticky;
        top: 0;
    }

    .globalAnswerSheetDiv {
        padding: 10px;
        box-sizing: border-box;
    }

    .globalAnswerSheetTagDiv {
        width: 100%;
        padding: 10px;
        background: #fff;
        box-sizing: border-box;
    }

    .globalAnswerSheetIndex {
        width: calc(100% / 5);
        display: inline-block;
        text-align: center;
    }

    .globalAnswerSheetIndexText {
        width: 40px;
        height: 40px;
        font-size: 16px;
        text-align: center;
        border-radius: 50%;
        line-height: 40px;
        border: 1px solid #aaa;
        box-sizing: border-box;
        margin: 5px auto;
    }

    .globalAnswerSheetIndexText[type='success'] {
        background-color: #07c160;
        border-color: #07c160;
        color: #fff;
    }

    .globalAnswerSheetIndexText[type='danger'] {
        background-color: #ee0a24;
        border-color: #ee0a24;
        color: #fff;
    }

    /* 自定义tabbar菜单 */
    .globalTabbarButtonDiv {
        width: 100%;
        height: 50px;
        overflow: hidden;
        display: flex;
        justify-content: space-around;
        position: sticky;
        bottom: 0;
        z-index: 1;
        border-top: 1px solid #eee;
        box-sizing: border-box;
        padding: 5px 0;
        background-color: #fff;
    }

    .globalTabbarButtonDiv i {
        font-size: 20px;
        line-height: 20px;
        height: 20px;
    }

    .globalTabbarButton {
        text-align: center;
        line-height: 20px;
        height: 20px;
        flex: 1;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue